import React, { useEffect, useState } from "react";
import CartPage from "../../components/Cart/Cart";
import {
  authsignature,
  getSession,
  headers,
  removeSession,
  setSession,
  storage,
} from "../../libs";
import { useHistory } from "react-router-dom";
import axios from "axios";
import ToastError from "../../components/Notification/ToastError";
import { ValCart } from "../../validation/CartValidation";
import Transfer from "../../components/Cart/Transfer";
import Covid from "../../components/Cart/Covid";
import { ValCovid } from "../../validation/CovidValidation";

/** Note

1. Satuan (Parameter)
2. Paket (Paket)
3. Media (Product)

**/

const vanila_covid = {
  vaksin_attemp: null,
  last_vaksin: "",
  tgl_bepergian: "",
  tujuan_bepergian: "",
  tujuan_pemeriksaan: 0,
  no_passport: "",
  negara_tujuan: "",
  tujuan_lain: "",
  is_vacation: false,
};

function Cart() {
  let dataSession = getSession();
  const history = useHistory();

  const [data, setData] = useState([]);
  const [layanan, setLayanan] = useState([]);
  const [covid, setCovid] = useState(vanila_covid);

  const [loading, setLoading] = useState(false);
  const [loadChat, setLoadChat] = useState(false);

  const [cash, setCash] = useState(0);
  const [cashOk, setCashOk] = useState(0);
  const [cashError, setCashError] = useState("");
  const [isBank, setBank] = useState([]);

  const [isError, setError] = useState("");
  const [isErrorCovid, setErrorCovid] = useState("");
  const [isErrorModal, setErrorModal] = useState("");

  const [isVisible, setVisible] = useState(false);
  const [isVisibleCovid, setVisibleCovid] = useState(false);
  const [isModal, setModal] = useState(false);

  const [isSucces, setSucces] = useState(false);
  const [dataTransfer, setDataTransfer] = useState({});

  const [tempData, setTempData] = useState({
    index: 0,
    id: 0,
    name: "",
    value: "",
  });

  const [open, setOpen] = useState(false);
  const [other, setOther] = useState(false);
  const [response, setResponse] = useState("");
  const onError = () => {
    setOpen(false);
  };

  useEffect(() => {
    if (dataSession) {
      const isSession = JSON.parse(dataSession); // get object paket (Info 2)
      const layanan = isSession.item.paket.concat(isSession.item.parameter); // get object satuan (Info 1)
      const product = layanan.concat(isSession.item.product); // get object media (Info 3)

      setData(product);
    } else {
      setData([]);
    }
    GetDataLayanan();
  }, [dataSession]);

  /** Handle Footer Layanan */
  const GetDataLayanan = async () => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/katalog/satuan`,
        { offset: 0, limit: 10 },
        { headers: await headers({ offset: 0, limit: 10 }) }
      );

      const auth = await storage();
      const payment = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/payment/method`,
        { offset: "0", limit: "10" },
        {
          headers: await authsignature(auth.token, {
            offset: "0",
            limit: "10",
          }),
        }
      );

      setBank(payment.data.data);

      if (Number(response.data.code) === 200) {
        setLayanan(response.data.data);
      } else {
        setOpen(true);
        setResponse("");
      }
    } catch (e) {
      setOpen(true);
      setResponse("");
    }
  };

  /** Handle Hapus Semua */
  const onRemoveAll = () => {
    removeSession();
    setData([]);
    history.push("/cart");
  };

  /** Handle Hapus yang dipilih */
  const onRemove = (index) => {
    let array = [...data]; // make a separate copy of the array
    let session = JSON.parse(dataSession);

    if (array.length === 1) {
      onRemoveAll();
    } else {
      if (array[index].info === 1) {
        session.item.parameter.splice(
          session.item.parameter.findIndex(
            (item) => item.id === array[index].id
          ),
          1
        );
        setSession(JSON.stringify(session));
      } else if (array[index].info === 2) {
        session.item.paket.splice(
          session.item.paket.findIndex((item) => item.id === array[index].id),
          1
        );
        setSession(JSON.stringify(session));
      } else if (array[index].info === 3) {
        session.item.product.splice(
          session.item.product.findIndex((item) => item.id === array[index].id),
          1
        );
        setSession(JSON.stringify(session));
      }
    }

    history.push("/cart");
  };

  /** Handle Quantity */
  const onQty = async (operator, index, id) => {
    let result = [...data];
    let session = await JSON.parse(dataSession);

    if (operator === "min") {
      result[index].qty = result[index].qty - 1;
    } else if (operator === "plus") {
      result[index].qty = result[index].qty + 1;
    }

    let idx = session.item.product.findIndex((it) => {
      return it.id === id;
    });

    if (session) {
      session.item.product[idx].qty = result[index].qty;
      session.item.product[idx].price =
        result[index].vanilla_price * result[index].qty;
    }
    result[index].price = result[index].vanilla_price * result[index].qty;
    setSession(JSON.stringify(session));
    setData(result);
  };

  /** Handle Input Modal*/
  const onChange = (e) => {
    const { name, value } = e.target;

    setTempData({ ...tempData, name, value });
  };

  /** Handle Input Change */
  const onSelect = async () => {
    setLoadChat(true);
    const error = await ValCart(tempData, "cart", false);
    if (error.length > 0) {
      setErrorModal(error);
      setLoadChat(false);
    } else {
      let session = JSON.parse(dataSession);
      let result = [...data];

      if (tempData.name === "tgl_pemeriksaan") {
        result[tempData.index].tgl_pemeriksaan = tempData.value;
      } else if (tempData.name === "jam_pemeriksaan") {
        result[tempData.index].jam_pemeriksaan = tempData.value;
      } else if (tempData.name === "note") {
        result[tempData.index].note = tempData.value;
      }

      if (result[tempData.index].info === 1) {
        // Handle Session Satuan
        let idx = session.item.parameter.findIndex((it) => {
          return it.id === tempData.id;
        });

        if (session) {
          session.item.parameter[idx][tempData.name] = tempData.value;
        }
      } else if (result[tempData.index].info === 2) {
        // Handle Session Paket
        let idx = session.item.paket.findIndex((it) => {
          return it.id === tempData.id;
        });

        if (session) {
          session.item.paket[idx][tempData.name] = tempData.value;
        }
      } else if (result[tempData.index].info === 3) {
        // Handle Session Product
        let idx = session.item.product.findIndex((it) => {
          return it.id === tempData.id;
        });

        if (session) {
          session.item.product[idx][tempData.name] = tempData.value;
        }
      }

      setSession(JSON.stringify(session));
      setData(result);
      setLoadChat(false);
      onCancel();
    }
  };

  /** Handle Klik Memilih Product */
  const onActive = (e, section, index, id, info) => {
    // section 1. All, 2. Per Index
    const { checked } = e.target;
    let session = JSON.parse(dataSession);

    if (section === 1) {
      let result = data.map((o) => Object.assign({}, o, { active: checked }));

      session.item.parameter =
        session.item.parameter.length > 0
          ? session.item.parameter.map((o) =>
              Object.assign({}, o, { active: checked })
            )
          : [];

      session.item.paket =
        session.item.paket.length > 0
          ? session.item.paket.map((o) =>
              Object.assign({}, o, { active: checked })
            )
          : [];

      session.item.product =
        session.item.product.length > 0
          ? session.item.product.map((o) =>
              Object.assign({}, o, { active: checked })
            )
          : [];
      setSession(JSON.stringify(session));
      setData(result);
    } else if (section === 2) {
      let result = [...data];

      result[index].active = checked;

      if (info === 1) {
        // Handle Session Satuan
        let idx = session.item.parameter.findIndex((it) => {
          return it.id === id;
        });

        if (session) {
          session.item.parameter[idx].active = checked;
        }
      } else if (info === 2) {
        // Handle Session Paket
        let idx = session.item.paket.findIndex((it) => {
          return it.id === id;
        });

        if (session) {
          session.item.paket[idx].active = checked;
        }
      } else if (info === 3) {
        // Handle Session Product
        let idx = session.item.product.findIndex((it) => {
          return it.id === id;
        });

        if (session) {
          session.item.product[idx].active = checked;
        }
      }

      setSession(JSON.stringify(session));
      setData(result);
    }
  };

  /** Modal Pembayaran */
  const showModal = (value) => {
    if (value === 1) {
      setVisible(true);
    } else if (value === 3) {
      setVisibleCovid(true);
    } else {
      setModal(true);
    }
  };

  /** Handle Close Modal */
  const onCancel = () => {
    setVisible(false);
    setModal(false);
    onReset();
    setCashError("");
    setErrorModal("");
  };

  /** Handle Add Metode Pembayarn Submit */
  const onSubmitCash = () => {
    // ini disaat modal akan di simpan
    if (!cash) {
      setCashError("Silahkan pilih metode pembayaran");
    } else {
      setCashOk(cash);
      onCancel();
      setCashError("");
    }
  };

  /**  Handle Metode Pembayaran */
  const onCash = (e) => {
    // ini disaat modal berjalan
    setCash(e.target.value);
    setCashError("");
    setError("");
  };

  /** Modal Change Input */
  const onModal = (index, id, name, value) => {
    setTempData({ index, id, name, value });
  };

  /** Reset Modal Value */
  const onReset = () => {
    setTempData({ index: 0, id: 0, name: "", value: "" });
  };

  /** Handle Add To Pay */
  const onSubmit = async () => {
    setLoading(true);
    let isEmpty = data.filter((it) => it.active).length === 0;
    let isCovid = data.filter((it) => it.is_covid === 1).length > 0;
    let submit = [...data];

    const time = submit.filter(
      (o) => o.active === true && o.jam_pemeriksaan.length === 0 && o.info !== 3
    );

    const date = submit.filter(
      (o) => o.active === true && o.tgl_pemeriksaan.length === 0 && o.info !== 3
    );

    if (!cashOk) {
      setError("silahkan pilih metode pembayaran");
      setLoading(false);
    } else {
      if (isEmpty) {
        setLoading(false);

        setOpen(true);
        setResponse(
          "Silahkan untuk memilih layanan kesehatan atau produk yang ingin dipesan"
        );
      } else if (date.length > 0 && time.length > 0) {
        setOpen(true);
        setResponse(
          "Silahkan untuk melengkapi data tanggal dan waktu yang ingin dipesan"
        );
      } else if (time.length > 0 || date.length > 0) {
        setLoading(false);

        if (time.length > 0) {
          setOpen(true);
          setResponse(
            "Silahkan untuk melengkapi data waktu yang ingin dipesan"
          );
        } else if (date.length > 0) {
          setLoading(false);
          setOpen(true);
          setResponse(
            "Silahkan untuk melengkapi data tanggal yang ingin dipesan"
          );
        }
      } else {
        try {
          const auth = await storage();

          const profile = await axios.post(
            `${process.env.REACT_APP_BACKEND_URL}/api/profile/detail`,
            { email: auth.xtoken },
            { headers: await authsignature(auth.token, { email: auth.xtoken }) }
          );

          if (Number(profile.data.code) === 200) {
            if (
              !profile.data.data.alamat ||
              !profile.data.data.kecamatan ||
              !profile.data.data.gender ||
              !profile.data.data.kelurahan ||
              !profile.data.data.kodepos ||
              !profile.data.data.kota ||
              !profile.data.data.provinsi ||
              !profile.data.data.tempat_lahir ||
              !profile.data.data.tgl_lahir
            ) {
              setLoading(false);

              setOpen(true);
              setResponse(
                "Untuk dapat checkout product tersebut, Silahkan lengkapi profile anda"
              );
              setOther(true);
            } else {
              // Checking layanan is covid or not
              if (isCovid) {
                setLoading(false);
                setVisibleCovid(true);
              } else {
                await onFinal(false);
              }
            }
          }
        } catch (error) {
          setLoading(false);

          setOpen(true);
          setResponse("");
        }
      }
    }
  };

  /** FInal data and save to database */
  const onFinal = async (is_covid) => {
    let submit = [...data];
    let session = JSON.parse(dataSession);
    const auth = await storage();
    const paymentMethod = cashOk;
    let dataSave = {
      payment_method: paymentMethod,
      item: { parameter: [], paket: [], product: [] },
    };

    const satuan = submit.filter((o) => o.active === true && o.info === 1);
    const paket = submit.filter((o) => o.active === true && o.info === 2);
    const product = submit.filter((o) => o.active === true && o.info === 3);

    const changeName = product.map(
      ({ tgl_pemeriksaan: tgl_pengambilan, ...rest }) => ({
        tgl_pengambilan,
        ...rest,
      })
    );

    const newSatuan = satuan.map(
      ({
        active,
        image,
        info,
        name,
        note,
        price,
        qty,
        vanilla_price,
        stock,
        is_covid,
        ...keep
      }) => keep
    );

    const newPaket = paket.map(
      ({
        active,
        image,
        info,
        name,
        note,
        price,
        qty,
        vanilla_price,
        stock,
        is_covid,
        ...keep
      }) => keep
    );

    const newProduct = changeName.map(
      ({
        active,
        image,
        info,
        name,
        price,
        vanilla_price,
        jam_pemeriksaan,
        tgl_pengambilan,
        stock,
        ...keep
      }) => keep
    );

    dataSave.item.parameter = newSatuan;
    dataSave.item.paket = newPaket;
    dataSave.item.product = newProduct;

    dataSave.item.product.forEach((item) => {
      if (item.note === "") {
        item.note = "Tidak ada catatan";
      }
    });

    if (is_covid) {
      if (!covid.is_vacation) {
        delete covid["tujuan_bepergian"];
        delete covid["tgl_bepergian"];
      }

      if (Number(covid.tujuan_pemeriksaan) !== 8) {
        delete covid["tujuan_lain"];
      }

      if (covid.tujuan_pemeriksaan !== 2) {
        delete covid["negara_tujuan"];
        delete covid["no_passport"];
      }

      delete covid["is_vacation"];

      dataSave.covid = covid;
    }

    const response = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}/api/payment/checkout`,
      dataSave,
      { headers: await authsignature(auth.token, dataSave) }
    );
    if (Number(response.data.code) === 200) {
      if (is_covid) {
        setVisibleCovid(false);
        setCovid(vanila_covid);
      }

      // Update Session Section
      const satuanOff = submit.filter(
        (o) => o.active === false && o.info === 1
      );
      const paketOff = submit.filter((o) => o.active === false && o.info === 2);
      const productOff = submit.filter(
        (o) => o.active === false && o.info === 3
      );
      session.item.parameter = satuanOff;
      session.item.paket = paketOff;
      session.item.product = productOff;
      if (
        session.item.parameter.length > 0 ||
        session.item.paket.length > 0 ||
        session.item.product.length > 0
      ) {
        setSession(JSON.stringify(session));
      } else {
        removeSession();
      }
      setDataTransfer(response.data.data);
      setSucces(true);
      setLoading(false);
    } else {
      setLoading(false);
      setOpen(true);
      setResponse("");
    }
  };

  /** Info Sukses Checkout */
  const onClose = () => {
    setSucces(false);
    history.push("/");
  };

  /** Move page if succes payment */
  const onMove = () => {
    setSucces(false);
    history.push("/profile/history");
  };

  /** Handle Close Modal Form Covid */
  const onCancelCovid = () => {
    setErrorCovid("");
    setVisibleCovid(false);
    setLoading(false);
    setCovid(vanila_covid);
  };

  const onCovid = (e) => {
    setErrorCovid("");
    const { name, value } = e.target;
    setCovid({
      ...covid,
      [name]:
        name === "tujuan_pemeriksaan" || name === "vaksin_attemp"
          ? Number(value)
          : value,
    });
  };

  const onSaveCovid = async () => {
    setLoading(true);

    const error = await ValCovid(covid);

    if (error.length > 0) {
      setErrorCovid(error);
      setLoading(false);
    } else {
      await onFinal(true);
    }
  };

  return (
    <>
      <ToastError props={{ open, response, onError, other }} />
      <Transfer props={{ isSucces, onClose, onMove, dataTransfer }} />
      <Covid
        props={{
          isVisibleCovid,
          onCancelCovid,
          covid,
          onCovid,
          loading,
          onSaveCovid,
          isError: isErrorCovid,
        }}
      />
      <CartPage
        props={{
          data,
          layanan,
          onRemove,
          onRemoveAll,
          onSelect,
          onChange,
          onActive,
          onSubmit,
          loading,
          loadChat,
          isVisible,
          isModal,
          showModal,
          onCancel,
          onCash,
          cash,
          cashOk,
          onSubmitCash,
          cashError,
          isError,
          isErrorModal,
          onModal,
          tempData,
          onQty,
          isBank,
          isVisibleCovid,
          onCancelCovid,
        }}
      />
    </>
  );
}

export default Cart;
